<template>
  <v-content>
    <v-layout pa-5 style="background-color: #000">
      <v-flex text-start white--text text-uppercase titleHeader>
        <span v-if="title === 'data-and-stats' || title === undefined">การจัดการ Data & Statistics</span>
        <span v-else-if="title === 'report'">การจัดการ Research & Report</span>
        <span v-else-if="title === 'cindex'">การจัดการ Creativity Index</span>
        <span v-else-if="title === 'about'">การจัดการ About</span>
        <span v-else-if="title === 'tsic'">การจัดการ กิจกรรมทางเศรษฐกิจ</span>
        <span v-else-if="title === 'group'">การจัดการ กลุ่มอุตสาหกรรมสร้างสรรค์</span>
        <span v-else-if="title === 'jobs'">การจัดการ อาชีพสร้างสรรค์</span>
        <span v-else-if="title === 'jobs-group'">การจัดการ กลุ่มอาชีพสร้างสรรค์</span>
        <span v-else-if="title === 'index'">การจัดการ ตัวชี้วัด</span>
        <span v-else-if="title === 'index-group'">การจัดการ กลุ่มตัวชี้วัด</span>
        <span v-else-if="title === 'title'">การจัดการ หัวข้อการนำเข้าข้อมูล</span>
        <span v-else-if="title === 'import'">การจัดการ การนำเข้าข้อมูลด้วยไฟล์ Excel</span>
        <span v-else-if="title === 'unit'">การจัดการ หน่วยของข้อมูล</span>
        <span v-else-if="title === 'tag'">การจัดการ Tag</span>
        <span v-else-if="title === 'users'">การจัดการ ผู้ใช้งานระบบ</span>
        <span v-else-if="title === 'footer'">การจัดการ Footer</span>
        <span v-else-if="title === 'number-box'">การจัดการกล่องข้อมูลหน้า Overview</span>
        <span v-else-if="title === 'number-box-datastats'">การจัดการกล่องข้อมูลหน้า Data and Statistics</span>
        <span v-else-if="title === 'downloads'">ดาวน์โหลดเอกสารใช้งานระบบ</span>
        <span v-else-if="title === 'banner'">การจัดการ Banner</span>
        <span v-else-if="title === 'main-menu'">การจัดการ Main Menu</span>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
export default {
  name: 'Header',
  props: ['title']

}
</script>

<style scoped></style>
